import { render, staticRenderFns } from "./BranchDetails.vue?vue&type=template&id=1a6c6aee&"
import script from "./BranchDetails.vue?vue&type=script&lang=js&"
export * from "./BranchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6c6aee')) {
      api.createRecord('1a6c6aee', component.options)
    } else {
      api.reload('1a6c6aee', component.options)
    }
    module.hot.accept("./BranchDetails.vue?vue&type=template&id=1a6c6aee&", function () {
      api.rerender('1a6c6aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/BranchDetails.vue"
export default component.exports